export const enableScroll = () => {
  document.body.style.overflow = "";
};

export const disableScroll = () => {
  document.body.style.overflow = "hidden";
};
